import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { createContext, useContext, useEffect, useState } from "react";

import WebHome from "./WebHome";
import MobileHome from "./MobileHome";
import { Outlet, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AuthContext } from "providers/AuthProvider";
import { requester } from "App";
import { Tab, TabList } from "react-tabs";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import style from "./ResponsiveHome.module.css";
import TopBar from "../top/TopBar";
import Dummy from "components/Dummy";
import Footer from "routes/front/footer/Footer";
import Container from "layouts/container/Container";
import { data } from "jquery";




function ResponsiveHomeLayout() {
    const { isMobile } = useContext(BrowserDetectContext);
    const navigate = useNavigate();
    const [seletedCategory, setSeletedCategory] = useState("all");
    const [products, setProducts] = useState();
    const [cateogories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [isMounted, setMounted] = useState(false);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]); // 하위카테고리
    const [filteredProducts, setFilteredProducts] = useState([]);
    const dispatch = useDispatch();
    const cartData = useSelector((state) => state.cart.products);
    const { userName } = useContext(AuthContext);
    const { id } = useParams();
    const location = useLocation();


    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (location.state) {
            if (location.state.selectedCategory === "") {
                setSeletedCategory("");
            }
        }
    }, [location])

    useEffect(() => {
        if (isMounted) {
            if (isMounted) {
                let data = { storeCode: id }
                requester.findAllVendorProducts(data, (result) => {
                    // setFilteredProducts(result.data);
                    setProducts(result.data);

                })
                requester.openfindAllCategory((result) => {
                    if (result.code === 0) {
                        const sortedCategories = result.data.sort((a, b) => {
                            if (a.categoryName === '기기') return -1;
                            if (b.categoryName === '기기') return 1;
                            return 0;
                        });

                        if (sortedCategories.length > 0) {
                            // '기기' 카테고리를 초기 선택 상태로 설정
                            const selectedCategoryId = sortedCategories[0].id;
                            setSeletedCategory("");


                            // 기본 카테고리와 하위 카테고리 목록 설정
                            const filteredCategories = sortedCategories.filter(category => category.parentCategoryId == null);
                            setCategories(filteredCategories);

                            const filteredSubCategories = sortedCategories.filter(category => category.parentCategoryId != null);
                            setSubCategories(filteredSubCategories);


                            const filteredSubCategories2 = sortedCategories.filter(category =>
                                category.parentCategoryId === selectedCategoryId);
                            setFilteredSubCategories(filteredSubCategories2);


                            // 선택된 카테고리에 해당하는 하위 카테고리 ID들을 가져옴
                            const subCategoryIds = filteredSubCategories
                                .filter(sc => sc.parentCategoryId === selectedCategoryId)
                                .map(sc => sc.id);

                            // 선택된 카테고리 또는 그 하위 카테고리에 해당하는 상품들만 필터링
                            requester.findAllVendorProducts(data, (allProductsResult) => {
                                const filteredProducts = allProductsResult.data.filter(p =>
                                    subCategoryIds.includes(p.categoryId) || p.categoryId === selectedCategoryId);
                                setFilteredProducts(filteredProducts);
                            });
                        }
                    }
                });
            }
        }
    }, [isMounted])



    const CategoryTab = (props) => {
        const { data, setFilteredProducts } = props;

        const categoryClick = () => {
            setSeletedCategory(data.id);

            const filteredSubCategories = subCategories.filter(subCategory =>
                subCategory.parentCategoryId === data.id
            );
            setFilteredSubCategories(filteredSubCategories);
            const subCategoryIds = subCategories.filter(sc => sc.parentCategoryId === data.id).map(sc => sc.id);
            const filteredProducts = products && products.filter(p => subCategoryIds.includes(p.categoryId));
            setFilteredProducts(filteredProducts);
            navigate(`/ws/${id}/homepage/list/${data.id}`, { state: { products: filteredProducts } })
        };

        return (
            <Tab
                style={{
                    width: props.width,
                    height: "50px",
                    backgroundColor: "#FE531F",
                    border: "none",
                    opacity: 0.6,


                }}
                selected={seletedCategory === data.id}
                selectedClassName={style.selected}
                onClick={categoryClick}
            >
                <Center>
                    <P weight={"bold"} size={"min(2.2vw, 25px)"} font={"gmarketSansBold"}>
                        {data && data.categoryName}
                    </P>
                </Center>
            </Tab>
        );
    }

    const allViewClick = (all) => {

        setSeletedCategory("all");

        const filteredSubCategories = subCategories.filter(subCategory =>
            subCategory.parentCategoryId === data.id
        );
        setFilteredSubCategories(filteredSubCategories);
        setFilteredProducts(products);
        navigate(`/ws/${id}/homepage/list/all`, { state: { products: products } })
    }



    return (
        <Container>
            <div className={style.topBar}>
                <TopBar />
            </div>
            <Dummy height={"50px"} />
            <TabList
                style={{
                    width: "100%",
                    height: "52px",
                    backgroundColor: "#FE531F",
                    margin: "0",
                    border: "none",
                    position: "fixed",
                    top: "40px",
                    zIndex: 1000,
                }}
            >
                <Container maxWidth={1200}>
                    {
                        cateogories && cateogories.map((data, index) => {
                            return (
                                <CategoryTab width={"20%"} data={data} setFilteredProducts={setFilteredProducts} />
                            );
                        })
                    }
                    <Tab
                        style={{
                            width: "17%",
                            height: "51px",
                            padding: "0 0 0 0px",
                            backgroundColor: "rgb(254, 83, 31)",
                            color: seletedCategory === "all" ? "white" : "rgba(255,255,255,0.6)", // 인라인 스타일로 텍스트 색상 직접 조정

                        }}
                        onClick={() => allViewClick("all")}
                        selected={seletedCategory === "all"}
                        selectedClassName={style.selected}
                    >
                        <Center>
                            <P weight={"bold"} size={"min(2.2vw, 25px)"} font={"gmarketSansBold"}>
                                전체보기
                            </P>
                        </Center>
                    </Tab>
                </Container>
            </TabList>
            <Dummy height={"44px"} />
            <div className={style.outlet}>
                <Outlet />
            </div>
            <Dummy height={"150px"} />
            <div style={{ position: "fixed", bottom: 0, zIndex: 1000 }}>
                <Footer />
            </div>
        </Container >
    );
}

export default ResponsiveHomeLayout;